import {
  registerStoryblokComponents,
  StoryblokComponentList,
} from "@made-people/grease-storyblok";

import { Footer } from "@made-people/blueprint-footer";
import { Menu, MenuItem } from "@made-people/blueprint-menu";
import { Topbar } from "@made-people/blueprint-topbar";
import { Banner } from "@made-people/blueprint-banner";
import { Table } from "@made-people/blueprint-table";
import { CentraSearchResultsProvider } from "@made-people/grease-centra";
import { GreaseGrowthbookExperimentContainer } from "@made-people/grease-growthbook";
import { ReviewCardSwiper } from "../components/blueprint/swiper/review-card-swiper/default-props";
import { CardBanner } from "../components/blueprint/banner/card-banner/default-props";
import { ProductQuickshop } from "../components/blueprint/product-quickshop/ProductQuickshop";
import { ButtonAsLink } from "@made-people/blueprint-button";
import { Grid } from "@made-people/blueprint-grid";
import { Swiper } from "@made-people/blueprint-swiper";
import { Accordion } from "@made-people/blueprint-accordion";
import { TextBlock } from "@made-people/blueprint-text-block";
import { SwipeableProductList } from "@made-people/blueprint-swipeable-product-list";
import { Search } from "@made-people/blueprint-search";
import { AlgoliaRecommendations } from "@made-people/grease-algolia";
import { MissMaryAlgoliaSearchResultsProvider } from "../components/features/algolia-search-results-provider/mm-algolia-search-results-provider";
import { Products } from "../components/blueprint/product-list/products/default-props";
import { RandomizedProductList } from "../components/blueprint/product-list/randomized/default-props";
import { LinkShortcuts } from "@made-people/blueprint-link-shortcuts";
import { PageHeader } from "@made-people/blueprint-page-header";
import { LinksHorizontalImages } from "@made-people/blueprint-links-horizontal-images";
import { LinksFluidImages } from "@made-people/blueprint-links-fluid-images";
import { LinksHoverImages } from "@made-people/blueprint-links-hover-images";
import { BlogPostMarkdown } from "@made-people/blueprint-blog-post-markdown";
import { BlogTeaser } from "@made-people/blueprint-blog-teaser";
import { BlogTeaserSlider } from "@made-people/blueprint-blog-teaser-slider";
import { PartnerLogos } from "@made-people/blueprint-partner-logos";
import { ActionCardToronto } from "@made-people/blueprint-action-card";
import { SwipeableLogos } from "@made-people/blueprint-swipeable-logos";
import { SwipeableBlogPosts } from "@made-people/blueprint-swipeable-blog-posts";
import { FeatureGroup } from "@made-people/blueprint-feature-group";
import { ReviewCard } from "@made-people/blueprint-review-card";
import { ImageAndText } from "@made-people/blueprint-image-and-text";
import { AccordionAndText } from "@made-people/blueprint-accordion-and-text";
import { LogosAndText } from "@made-people/blueprint-logos-and-text";
import { TrustpilotReviews } from "../components/features/trustpilot/components/trustpilot-reviews";
import { CheckoutInformationCard } from "../components/global/CheckoutInformationCard";
import { MiniCartSwipeableProductList } from "../components/blueprint/swipeable-product-list/mini-cart-swipeable/default-props";
import { MMUpsellProductList } from "../components/features/upsell/MMUpsellProductList";
import { InretrnWidget } from "../components/features/inretrn/inretrn-widget";
import { InretrnWithdrawWidget } from "../components/features/inretrn/inretrn-withdraw-widget";
import { NonInretrnWithdrawForm } from "../components/features/inretrn/non-inretrn-withdraw-form";
import { SizeGuideCalculator } from "../components/features/size-guide/size-guide-calculator";
import { SizeGuideTableStoryblok } from "../components/features/size-guide/size-guide-table-storyblok";
import { BlogList } from "../components/features/blog/blog-list";
import { OrderTracking } from "../components/features/order-tracking/order-tracking";
import { CookieDeclaration } from "../components/features/cookie-declaration/cookie-declaration";
import { MmSizeSelectorOverlay } from "../components/features/size-selector-overlay/mm-size-selector-overlay";
import { ProductListCategoriesCollection } from "../components/features/product-list-categories-collection/product-list-categories-collection";
import { LoadCentraCategoryDescription } from "../components/features/plp-centra-description/load-centra-category-description";
import { ProductListWithContent } from "../components/features/plp-content/ProductListWithContent";
import { ProductListBanner } from "../components/features/plp-content/ProductListBanner";
import { ProductListTextCard } from "../components/features/plp-content/ProductListTextCard";

/**
 * Register all Storyblok components that are used in the app.
 *
 * The object's key is the component name in Storyblok, and the value
 * is the React component that should be used to render it.
 */
registerStoryblokComponents({
  ActionCardToronto,
  Banner,
  ButtonAsLink,
  LinkShortcuts,
  LinksHorizontalImages,
  LinksFluidImages,
  LinksHoverImages,
  PageHeader,
  BlogTeaser,
  Grid,
  CardBanner,
  Swiper,
  BlogPostMarkdown,
  TextBlock,
  CentraSearchResultsProvider,
  ProductList: ProductListWithContent,
  Products,
  RandomizedProductList,
  MarketContainer: StoryblokComponentList,
  CountryContainer: StoryblokComponentList,
  LanguageContainer: StoryblokComponentList,
  ContentGroup: StoryblokComponentList,
  AlgoliaSearchProvider: MissMaryAlgoliaSearchResultsProvider,
  AlgoliaSearchResultsProvider: MissMaryAlgoliaSearchResultsProvider,
  AlgoliaRecommendations: AlgoliaRecommendations,
  TrustpilotBanner: TrustpilotReviews,
  Topbar,
  Search,
  SwipeableProductList,
  SwipeableLogos,
  SwipeableBlogPosts,
  FeatureGroup,
  ReviewCard,
  ProductQuickshop,
  InformationCard: CheckoutInformationCard,
  ReviewCardSwiper,
  PartnerLogos,
  ImageAndText,
  Footer,
  Accordion,
  BlogTeaserSlider,
  AccordionAndText,
  MainMenu: Menu,
  MenuItem,
  LogosAndText,
  Table,
  SizeGuideTable: SizeGuideTableStoryblok,
  GreaseGrowthbookExperimentContainer,
  MiniCartSwipeableProductList,
  MMUpsellProductList,
  InretrnWidget,
  InretrnWithdrawWidget,
  NonInretrnWithdrawForm,
  SizeGuideCalculator,
  BlogList,
  OrderTracking,
  CookieDeclaration,
  SizeSelectorOverlay: MmSizeSelectorOverlay,
  ProductListCategoriesCollection,
  LoadCentraCategoryDescription,
  ProductListBanner,
  ProductListTextCard,
});
